<dx-data-grid *ngIf="initialized"
	[dataSource]="tarifs"
	[allowColumnReordering]="true"
	[columnAutoWidth]="true"
	[allowColumnResizing]="true"
	[showBorders]="true"
	[height]="'100%'"
	(onInitNewRow)="onInitNewRow($event)"
	(onRowPrepared)="onRowPrepared($event)"
	(onRowInserting)="onRowInserting($event.data)"
	(onRowUpdating)="onRowUpdating($event)"
	(onRowRemoving)="onRowRemoving($event.key)"
	(onEditingStart)="onEditingStart($event.data)"
	(onSaving)="onSaving($event)"
>
	<!-- Toolbar -->
	<dxo-toolbar>
		<dxi-item location="before">
			<div *dxTemplate>
				<i id="tarifArticleLegendeIcon" style="font-size: 18px; cursor: pointer;" class="dx-icon-info" (mouseenter)="showLegende = true" (mouseleave)="showLegende = false"></i>
			</div>
		</dxi-item>
		<dxi-item>
			<div *dxTemplate>
				<app-reset-grid-state [dataGrid]="dataGrid"></app-reset-grid-state>
			</div>
		</dxi-item>
		<dxi-item>
			<div *dxTemplate>
				<dx-button icon="refresh" hint="Rafraîchir" stylingMode="text" (onClick)="setTarifs()"></dx-button>
			</div>
		</dxi-item>
		<dxi-item name="columnChooserButton"></dxi-item>
		<dxi-item name="addRowButton"></dxi-item>
	</dxo-toolbar>

	<!-- Options -->
	<dxo-editing mode="popup" [allowAdding]="isModificationAutorisee" [allowUpdating]="isModificationAutorisee" [allowDeleting]="isModificationAutorisee">
		<dxo-popup title="Tarif" [showTitle]="true" [width]="700" [height]="525" [showCloseButton]="true"></dxo-popup>
		<dxo-form #form>
			<dxi-item dataField="prixId" [label]="{text: 'Prix'}" editorType="dxSelectBox"
				[editorOptions]="{
					dataSource: prixDataSource,
					searchEnabled: true,
					displayExpr: 'libelleLong',
					valueExpr: 'id',
					showClearButton: true,
					searchExpr: ['libelleLong', 'codeBo', 'libelleCourt'],
					showDataBeforeSearch: true,
				}"
			>
				<dxi-validation-rule type="required"></dxi-validation-rule>
			</dxi-item>
			<dxi-item dataField="valeur" [label]="{text: 'Valeur'}" editorType="dxNumberBox" [disabled]="isPrixSaisiVente"></dxi-item>
			<dxi-item dataField="pmp" [disabled]="true" [label]="{text: 'PMP'}" editorType="dxNumberBox"></dxi-item>
			<dxi-item dataField="prixDetail" [label]="{text: 'Prix détail'}" editorType="dxNumberBox"></dxi-item>
			<dxi-item  dataField="valeurProchaine" [label]="{text: 'Valeur prochaine'}" editorType="dxNumberBox" [editorOptions]="{onValueChanged : onValeurProchaineChanged, showClearButton : true}"></dxi-item>
			<dxi-item dataField="dateProchaine" [label]="{text: 'Date prochaine'}" editorType="dxDateBox"
				[editorOptions]="{displayFormat: 'dd/MM/yyyy HH:mm:ss', type: 'datetime', showClearButton: true}"
			></dxi-item>
			<dxi-item #valeurProchaine dataField="commentaireValeurProchaine" [label]="{text: 'Commentaire valeur prochaine'}"  [editorOptions]="{showClearButton: true}" ></dxi-item>
			<dxi-item dataField="saisiePrix" [label]="{visible: false}" editorType="dxCheckBox" [editorOptions]="{text: 'Valeur saisi à la vente', onSaisieVenteChanged}"></dxi-item>
		</dxo-form>
	</dxo-editing>
	<dxo-column-chooser [enabled]="true" mode="select" [height]="600"></dxo-column-chooser>
	<dxo-state-storing [enabled]="true" storageKey="grille_fiche_article_tarifs" appStorage></dxo-state-storing>

	<!-- Colonnes -->
	<dxi-column caption="Prix" [allowEditing]="false" cellTemplate="prixCellTemplate">
		<div *dxTemplate="let cell of 'prixCellTemplate'">
			{{cell.data.prixCodeBo}} - {{cell.data.prixIntitule}}
		</div>
	</dxi-column>
	<dxi-column dataField="pmp" caption="Prix de revient" *ngIf="isAffichagePMPAutorise"></dxi-column>
	<dxi-column dataField="prixTtc" caption="Prix TTC" [allowEditing]="false"></dxi-column>
	<dxi-column dataField="prixHt" caption="Prix HT" [allowEditing]="false"></dxi-column>
	<dxi-column dataField="prixDetail" caption="Prix détail" [visible]="showPrixDetail"></dxi-column>
	<dxi-column dataField="prixTypeTaxe" caption="Type" [allowEditing]="false">
		<dxo-lookup [dataSource]="typeTaxeDataSource" displayExpr="intitule" valueExpr="id"></dxo-lookup>
	</dxi-column>
	<dxi-column dataField="sommeTauxTaxes" caption="Taxes (%)" [width]="98" [visible]="false" [allowEditing]="false"></dxi-column>
	<dxi-column caption="Coefficient" [calculateCellValue]="calculateCoefficient" [width]="110" *ngIf="isAffichagePMPAutorise">
		<dxo-format type="fixedPoint" [precision]="2"></dxo-format>
	</dxi-column>
	<dxi-column caption="Marge" [calculateCellValue]="calculateMargeBrute" [width]="120" *ngIf="isAffichagePMPAutorise"></dxi-column>
	<dxi-column caption="Marge (%)" [calculateCellValue]="calculateTauxMarge" [width]="101" *ngIf="isAffichagePMPAutorise">
		<dxo-format type="percent" [precision]="2"></dxo-format>
	</dxi-column>
	<dxi-column caption="Marque (%)" [calculateCellValue]="calculateTauxMarque" [width]="111" *ngIf="isAffichagePMPAutorise">
		<dxo-format type="percent" [precision]="2"></dxo-format>
	</dxi-column>
	<dxi-column dataField="saisiePrix" caption="Saisie prix" dataType="boolean" [visible]="false" [setCellValue]="setSaisiePrixCellValue"></dxi-column>
	<dxi-column type="buttons">
		<dxi-button name="edit" icon="edit" hint="Editer"></dxi-button>
		<dxi-button name="delete" icon="trash" hint="Supprimer"></dxi-button>
		<dxi-button icon="clock" hint="Voir l'historique du tarif" [onClick]="showHistoriqueTarif"></dxi-button>
	</dxi-column>

	<!-- #region Colonnes masquées et non affichables -->
	<dxi-column dataField="prixId" caption="Id Prix" [visible]="false" [showInColumnChooser]="false"></dxi-column>
	<dxi-column dataField="valeur" caption="Valeur" [visible]="false" [showInColumnChooser]="false">
		<dxi-validation-rule type="custom" [validationCallback]="checkCanSaisirValeur"></dxi-validation-rule>
	</dxi-column>
	<dxi-column dataField="dateProchaine" caption="Date prochaine" [visible]="false" [showInColumnChooser]="false" dataType="date" format="dd/MM/yyyy HH:mm"></dxi-column>
	<dxi-column dataField="valeurProchaine" caption="Valeur prochaine" [visible]="false" [showInColumnChooser]="false"></dxi-column>
	<dxi-column dataField="commentaireValeurProchaine" caption="Commentaire valeur prochaine" [visible]="false" [showInColumnChooser]="false"></dxi-column>
	<!-- #endregion -->
</dx-data-grid>


<!-- Popover: Légende couleur -->
<dx-popover
	target="#tarifArticleLegendeIcon"
	[width]="300"
	[showTitle]="true"
	title="Légende :"
	[(visible)]="showLegende"
>
	<div *dxTemplate="let data = model; of: 'content'">
		<span class="prix-de-base">Vert</span> = prix de base, définit.<br><br>
		<span class="prix-calcule">Gris</span> = prix calculé / déduit du prix de base et des taxes.<br><br>
	</div>
</dx-popover>


<!-- Popup : historique d'un tarif -->
<dx-popup
  [showTitle]="true"
  height="600"
  title="Historique des tarifs"
  [(visible)]="showPopupHistoriqueTarif"
>
  <div style="display: flex; flex-direction:column; justify-content: space-between; height: 500px;" *dxTemplate="let data = model; of: 'content'">
    <app-tarif-article-historique *ngIf="showPopupHistoriqueTarif" [tarifId]="historiqueTarifId"></app-tarif-article-historique>
	<div style="display: flex; justify-content: end; align-items: center; margin-top: 0.5rem">
		<dx-button class="action-button" text="Fermer" type="danger" icon="close"
				   (onClick)="this.showPopupHistoriqueTarif=false;"
		>
		</dx-button>
	  </div>
  </div>
</dx-popup>
